var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablePaginationLeftArrowGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4267 4.09725C13.0658 3.75355 12.4807 3.75355 12.1198 4.09725L6.57535 9.37772C6.21447 9.72141 6.21447 10.2786 6.57535 10.6223L12.1198 15.9028C12.4807 16.2465 13.0658 16.2465 13.4267 15.9028C13.7876 15.5591 13.7876 15.0019 13.4267 14.6582L8.53562 10L13.4267 5.34187C13.7876 4.99817 13.7876 4.44094 13.4267 4.09725Z",
    fill: "url(#paint0_linear_1502_66015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1502_66015",
    x1: 6.30469,
    y1: 10.0005,
    x2: 13.6973,
    y2: 10.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePaginationLeftArrowGold);
export default __webpack_public_path__ + "static/media/Table_Pagination_Left_Arrow_Gold.b10406b346ccab88148a15f172f21ba7.svg";
export { ForwardRef as ReactComponent };